export default __webpack_public_path__ + "static/screeny-110-gc-scheda-tecnica-63ef16de390ff2d73d5556eba75bb4a2.pdf";